/* eslint-disable react/prop-types */

import { Route, withRouter } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import routerService from "../../Router";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useUser } from "../../core/context/user";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { useEffect, useState } from "react";
import { refreshToken, refreshUserToken } from "../../core/api/user";

const DefaultLayout = (props) => {
  const { match } = props;
  const { isCurrentUserSuperAdmin, isUserLoggedIn, updateUser } = useUser();
  const [isLoading, setIsLoading] = useState(true);

  const validateRoute = (path) => {
    if (isCurrentUserSuperAdmin()) {
      return true;
    }
    if (path === "users") {
      return false;
    }
    return true;
  };

  useEffect(() => {
    const refreshTokens = async () => {
      try {
        setIsLoading(true);
        const refreshToken = localStorage.getItem("refreshToken");
        const res = await refreshUserToken(refreshToken);
        console.log("res", res);
        if (res.success) {
          console.log("User token refreshed successfully", res.data.user);
          updateUser(res.data.user);
          localStorage.setItem("token", res.data.token);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    refreshTokens();
  }, []);

  return (
    <>
      <div className="main-wrapper">
        {!isLoading && <Header />}
        <div>
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </div>
          ) : (
            routerService &&
            isUserLoggedIn() &&
            routerService.map((route, key) => {
              if (validateRoute(route.path)) {
                return (
                  <Route
                    key={key}
                    exact={route?.exact}
                    path={`${match.url}/${route.path}`}
                    component={route.component}
                  />
                );
              }
            })
          )}
          {!isUserLoggedIn() && !isLoading && <Redirect to="/signIn" />}
        </div>
        {!isLoading && <Sidebar />}
      </div>
      <div className="sidebar-overlay"></div>
    </>
  );
};

export default withRouter(DefaultLayout);